<template>
    <div>
        <card title="Centro de Costos" icon="fas fa-hand-holding-usd">
            <master-options @showModal="showModal" :withMassiveImport="true" @showMassiveCostCenterUserUpdate="showMassiveCostCenterUserUpdate" :links="links" @index="index" @reset="reset"></master-options>
            <div class="table-responsive">
                <manage-table :hover="true" :headers="['Id', 'Nombre', 'Descripción', 'Unidad de Negocio Asociada', 'Usuarios Asignados']"
                    :hasOptions="true">
                    <tr v-for="cc in ListCostCenter" :key="cc.id">
                        <td>{{ cc.id }}</td>
                        <td>{{ cc.name }}</td>
                        <td>{{ cc.description }}</td>
                        <td><span class="badge badge-info">{{ cc.businessUnitName }}</span></td>
                        <td>
                            <span class="badge badge-success p-2">{{ cc.userCostCenterCount }}</span>
                        </td>
                        <td class="text-right">
                            <button class="btn btn-info btn-sm mr-2" @click="showModal(cc)" data-toggle="tooltip"
                                data-placement="top" title="Editar Centro de Costo">
                                <i class="fas fa-edit"></i>
                            </button>
                            <button class="btn btn-primary btn-sm mr-2" @click="showCostCenterUsersModal(cc)" data-toggle="tooltip"
                                data-placement="top" title="Editar Usuarios por Centro de Costo">
                                <i class="fas fa-users"></i>
                            </button>
                            <button title="Eliminar Centro de Costo" class="btn btn-danger btn-sm "
                                @click="deleteCostCenter(cc.id, cc.name)" data-toggle="tooltip" data-placement="top">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </manage-table>
            </div>
            <paginator class="mt-4" :links="links"></paginator>
        </card>
        <modal id="costCenterFormModal" :title="modalTitle" @modalClose="index">
            <cost-center-form :cCenter="cCenter" :businessUnits="businessUnits" @pressOk="save"></cost-center-form>
        </modal>
        <modal id="costCenterUsersFormModal" title="Asignación de Usuarios" @modalClose="index" :lg="true">
            <cost-center-users-form :cCenter="cCenter" :users="users" :currentUsers="currentUsers" @saveCostCenterUser="saveCostCenterUser"></cost-center-users-form>
        </modal>
        <modal id="massiceCostCenterUsersFormModal" title="Asignación Masiva de Usuarios" @modalClose="index" :md="true">
            <massive-cost-center-users-form ref="massiveCostCenterUserComponent" @saveMassiveCostCenterUser="saveMassiveCostCenterUser"></massive-cost-center-users-form>
        </modal>
    </div>
</template>

<script>
import { Get, Delete, Post, Put } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
import $ from "jquery";
import { getUrlQuery } from "../../helper/queryHelper";
export default {
    components: {
        Card
    },
    data() {
        return {
            ListCostCenter: [],
            Post,
            Delete,
            apiUrl: this.$store.getters.apiUrl,
            modalTitle: '',
            Get,
            Put,
            cCenter: {},
            links: {},
            getUrlQuery,
            businessUnits: [],
            users: [],
            currentUsers: []
        };
    },
    watch: {
        urlQuery: function () {
            this.index()
        }
    },
    created() {
        this.index();
        this.getBusinessUnits();
    },
    methods: {
        index() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/costcenters?" + this.urlQuery, res => {
                this.ListCostCenter = res.data.data;
                this.links = res.data.links;
                this.$store.commit("setLoading", false);
            });
        },
        getBusinessUnits() {
            this.$store.commit("setLoading", true);
            this.businessUnits = []
            this.Get(this.apiUrl + 'v1/businessunits?', (res) => {
                res.data.data.forEach(element => {
                    this.businessUnits.push({ label: element.name, code: element.id })
                });
                this.$store.commit("setLoading", false);
            });
        },
        reset() {
            this.links = {}
            this.index()
        },
        save() {
            if (this.cCenter.id)
                this.update()
            else
                this.store()

        },
        showModal(cCenter) {
            if (cCenter && cCenter.id) {
                this.modalTitle = "Actualizar Centro de Costo";
                this.cCenter = cCenter;
            } else {
                this.modalTitle = "Crear Centro de Costo";
                this.cCenter = {};
            }
            $('#costCenterFormModal').modal('show');
        },
        showCostCenterUsersModal(cCenter) {
            this.cCenter = cCenter;
            this.users = [];
            this.currentUsers = [];
            this.getAvailableUsers();
            this.getCurrentUsers();
            $('#costCenterUsersFormModal').modal('show');
        },
        showMassiveCostCenterUserUpdate() {
            this.$nextTick(() => {
                this.$refs.massiveCostCenterUserComponent.resetView(); // reinicia el hijo
            });
            $('#massiceCostCenterUsersFormModal').modal('show');
        },
        deleteCostCenter(id, name) {
            this.$swal({
                title: "¿Desea eliminar la Centro de Costo?",
                text: name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            }).then(result => {
                if (result.value) {
                    this.Delete(this.apiUrl + 'v1/costcenters/' + id, () => {
                        window.toastr.success('Centro de Costo Eliminado correctamente.');
                        this.index();
                    });
                }

            });
        },
        update() {
            this.$store.commit("setLoading", true);
            this.Put(this.apiUrl + "v1/costcenters/" + this.cCenter.id, this.cCenter, () => {
                $('#costCenterFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Centro de Costo Actualizado correctamente.');
                this.reset();
            });

        },
        store() {
            this.$store.commit("setLoading", true);
            this.Post(`${this.apiUrl}v1/costcenters/`, this.cCenter, () => {
                $('#costCenterFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Centro de Costo Registrado correctamente.');
                this.reset();
            })
            this.cCenter = {};
        },
        getAvailableUsers(){
            if (this.cCenter)
            {
                this.$store.commit('setLoading',true)
                this.Get(this.apiUrl + "v1/CostCenterUsers/GetUsersAvailable/"+this.cCenter.id, (res) => {
                    res.data.data.forEach((item) => {
                        this.users.push({
                            code: item.id,
                            label: item.email + ' - ' + item.fullName,
                            email: item.email,
                            fullName: item.fullName,
                            roles: item.roles,
                            id: item.id
                        })
                    });
                    this.$store.commit('setLoading',false)
                });
            }
		},
        getCurrentUsers(){
            if (this.cCenter)
            {
                this.$store.commit('setLoading',true)
                this.Get(this.apiUrl + "v1/CostCenterUsers/GetCurrentUserByCostCenter/"+this.cCenter.id, (res) => {
                    res.data.data.forEach((item) => {
                        this.currentUsers.push({
                            code: item.id,
                            label: item.email + ' - ' + item.fullName,
                            email: item.email,
                            fullName: item.fullName,
                            roles: item.roles,
                            id: item.id
                        })
                    });
                    this.$store.commit('setLoading',false)
                });
            }
		},
        saveCostCenterUser(){
            $('#costCenterUsersFormModal').modal('hide');
            this.index();
        },
        saveMassiveCostCenterUser(){
            $('#massiceCostCenterUsersFormModal').modal('hide');
            this.index();
        }
    },
    computed: {
        urlQuery() {
            return this.getUrlQuery()
        }
    }

}

</script>